import { Helmet } from '@dr.pogodin/react-helmet';
import { Route, Routes } from 'react-router';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import Functions from '../functions';
import './assets/d3forum_common.css';
import './assets/d3forum_main.css';
import D3ForumCategory from './D3ForumCategory';
import D3ForumForum from './D3ForumForum';
import D3ForumPost from './D3ForumPost';
import D3ForumTop from './D3ForumTop';
import D3ForumTopic from './D3ForumTopic';
import D3ForumUtils from './lib/D3ForumUtils';

interface Props {
    lang: MultiLang;
    name: string;
}

const D3Forum = (props: Props) => {
    const { lang, name } = props;
    return (
        <>
            <Helmet>
                <title>
                    {D3ForumUtils.getTitle(name, lang)} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <Routes>
                <Route path="/" element={<D3ForumTop lang={lang} name={name} />} />
                <Route path="category/:id" element={<D3ForumCategory lang={lang} name={name} />} />
                <Route path="forum/:id" element={<D3ForumForum lang={lang} name={name} />} />
                <Route path="topic/:id" element={<D3ForumTopic lang={lang} name={name} />} />
                <Route path="post/:id" element={<D3ForumPost lang={lang} name={name} />} />
                <Route path="*" element={<PageNotFound lang={lang} />} />
            </Routes>
        </>
    );
};

export default D3Forum;
